// v0.45.9  — initial wordmark: dotless-i + overlaid blue pin head.
// v0.45.16 — first redesign (stylised stem + circle "i").
// v0.45.18 — Brett: "literally grab one of the pins and replace the i".
//
// The "i" in DropPin is now the EXACT 3D pushpin SVG used on the plan
// canvas (PlanScreen.jsx v0.45.5/v0.45.11): glossy spherical head, thin
// angled grey stem with highlight, soft shadow at the tip. Same viewBox
// (40 × 60), tip anchored at (12, 56) — that's the bottom-left of the
// glyph and lines up with the text baseline.
//
// Pin head colour matches the canvas brand-orange (theme.brand) by
// default — same colour the actual pins use on the plan, not the stylised
// blue from earlier wordmark revs. Brett's instruction was "grab one of
// the pins", so the pin should look like the pins.

import React from 'react';

// Brand orange — matches theme.brand and the canvas pin defaults.
const PIN_HEAD_FILL_DEFAULT = '#fb923c';

export default function DropPinWordmark({
  // Override the surrounding text colour (defaults to inherit).
  color,
  // Pin head colour. Defaults to brand orange (matches canvas pins).
  // Pass a different hex for cover surfaces that want a different accent.
  dotColor = PIN_HEAD_FILL_DEFAULT,
  // Inline style overrides for the wrapping span.
  style,
}) {
  return (
    // The "i" is a drawing, so the letters alone read "Droppn": the name is
    // given once, whole, and the pieces are hidden from screen readers.
    <span
      role="img"
      aria-label="DropPin"
      style={{
        display: 'inline-flex',
        alignItems: 'baseline',
        whiteSpace: 'nowrap',
        color: color || 'inherit',
        ...style,
      }}
    >
      <span aria-hidden>Dropp</span>
      {/*
        The "i" — the actual canvas pushpin SVG. ViewBox 40×60 with the
        tip at (12, 56). Wrapper sizing:
          width ≈ 0.65em — narrow enough to read as one letter
          height ≈ 1.1em — head sits above x-height like a tittle
        verticalAlign 'baseline' + a small marginBottom offset slides
        the tip down to sit cleanly on the text baseline.
      */}
      <svg
        aria-hidden
        viewBox="0 0 40 60"
        preserveAspectRatio="xMidYMax meet"
        style={{
          width: '0.65em',
          height: '1.1em',
          display: 'inline-block',
          verticalAlign: 'baseline',
          overflow: 'visible',
          // Small negative margin so the tip kisses the baseline.
          marginBottom: '-0.05em',
          // Tiny horizontal breathing room either side.
          margin: '0 0.02em -0.05em',
        }}
      >
        {/* Shadow on the surface */}
        <ellipse cx="12" cy="56" rx="7" ry="1.8" fill="rgba(0,0,0,0.35)" />
        {/* Stem — angled grey needle */}
        <line x1="12" y1="55" x2="22" y2="24" stroke="#5b6470" strokeWidth="2.6" strokeLinecap="round" />
        {/* Stem highlight (white glint along the shaft) */}
        <line x1="12.5" y1="54" x2="21.5" y2="24" stroke="rgba(255,255,255,0.35)" strokeWidth="0.8" strokeLinecap="round" />
        {/* Spherical head */}
        <circle cx="22" cy="18" r="12" fill={dotColor} stroke="rgba(0,0,0,0.25)" strokeWidth="1" />
        {/* Gloss highlight upper-left */}
        <ellipse cx="18" cy="13" rx="4.5" ry="2.8" fill="rgba(255,255,255,0.55)" />
      </svg>
      <span aria-hidden>n</span>
    </span>
  );
}
